$shm_remove_menu $mol_pick
	align \bottom_left
	remove_confirmed? false
	remove? null
	remove_confirm? null
	remove_accept? null
	remove_cancel? null
	remove_title \Удалить
	remove_confirm_title \Удалить?
	remove_yes_title \Да
	remove_no_title \Нет
	trigger_content /
		<= Menu_trigger $mol_view
			sub /
				<= Menu_trigger_icon $mol_icon_dots_vertical
	bubble_content /
		<= Menu $mol_view
			sub <= menu_rows /
	Remove_button $mol_button_minor
		title <= remove_title
		click? <=> remove_confirm? null
	Confirm $mol_view
		sub /
			<= Remove_text $mol_view
				sub / <= remove_confirm_title
			<= Confirm_actions $mol_view
				sub /
					<= Remove_yes $mol_button_minor
						title <= remove_yes_title
						click? <=> remove_accept? null
					<= Remove_no $mol_button_minor
						title <= remove_no_title
						click? <=> remove_cancel? null
	menu_rows /
